import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useLocaleStore } from "@store/useLocaleStore";

/** Connects a component's local i18n instance to the page-wide locale store. */
export function useLocale() {
  const localeStore = useLocaleStore();
  const { locale: i18nLocale } = useI18n({ useScope: "global" });

  watch(
    () => localeStore.locale,
    (locale) => {
      i18nLocale.value = locale;
    },
    { immediate: true },
  );

  const locale = computed({
    get: () => localeStore.locale,
    set: (value: string) => localeStore.setLocale(value),
  });

  return { locale };
}
